import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ReactGA from 'react-ga4';
import ScrollToTop from './ScrollToTop';

import PaymentSuccess from './PaymentSuccess'
import HHO from './HHO';
import LANDING from './LANDING';
import FAQ from './Faq';
import CLAIM from './Claims';

ReactGA.initialize([{
	trackingId: 'G-M493TM1YDS',
	debug: true,
	gtagOptions: {
		cookieDomain: 'auto',
 		allowAdFeatures: true
	},

}]);

ReactGA.event({
  category: "your category",
  action: "your action",
  label: "your label", // optional
  value: 99, // optional, must be a number
  nonInteraction: true, // optional, true/false
  transport: "xhr", // optional, beacon/xhr/image
});


export default () => {
	const [basicName, setBasicName] = useState("");
	const [basicContactNo, setBasicContactNo] = useState("");
	const [basicEmailAdd, setBasicEmailAdd] = useState("");
    	const [referral, setReferral] = useState('');


	useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const rParam = urlParams.get('r');
  
        if (rParam) {
          sessionStorage.setItem('referral', rParam);
          setReferral(rParam);
        }

  
      }, []);

	useEffect(() => {
        //ReactGA.pageview(window.location.pathname + window.location.search);
		ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search,title:"House"});

 	});


	return (
		<Router>
			<div id="content-wrapper" className="container-fluid">
				<nav className="navbar navbar-light navbar-expand-lg bg-transparent">
					<div className="container">
						<div className="navbar-brand d-flex text-white clickable">
							<a href={process.env.MIX_INSTAPOL_DOMAIN}>
								<img className="instapol-logo" src="../images/new-logo-white.png" alt="Howden Insurance Brokers Sdn Bhd" loading="lazy" />
							</a>
						</div>
						<button className="navbar-toggler text-white border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbar" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
							<i className="fas fa-bars" />
						</button>
						<div className="collapse navbar-collapse" id="navbar">
							<ul className="navbar-nav ms-auto">
								<li className="nav-item">
									<a className="nav-link text-white fw-bold" href="https://instapol.my/">Home</a>
								</li>
								<li class="nav-item dropdown">
									<a class="nav-link dropdown-toggle text-white fw-bold" href="#" id="productDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
										Our Products
									</a>
									<ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/motor"}>Motor Insurance</a></li>
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/bike"}>Bicycle Insurance</a></li>
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/travel"}>Travel Insurance</a></li>
									</ul>
								</li>

								<li className="nav-item dropdown">
									<a className="nav-link dropdown-toggle text-white fw-bold" id="aboutDropdown" role="button" data-bs-toggle="dropdown"  aria-haspopup="false" aria-expanded="false">
										About Us
									</a>
									<ul className="dropdown-menu" aria-labelledby="aboutDropdown">
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/about-us"}>About instaPol</a></li>
										<li><a className="dropdown-item" href="https://www.howdengroup.com/my-en/privacy-and-data-protection">Privacy Policy</a></li>
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/refund-policy"}>Refund Policy</a></li>
										<li><a className="dropdown-item" href="https://www.howdengroup.com/my-en/cookies">Cookies Policy</a></li>
										<li><a className="dropdown-item" href="https://www.howdengroup.com/my-en/terms-and-conditions">Terms and Conditions</a></li>
									</ul>
								</li>
								{/* <li className="nav-item dropdown">
									<a className="btn btn-outline-primary text-white fw-bold dropdown-toggle" id="pdsDropdown" role="button" data-toggle="dropdown" aria-haspopup="false" aria-expanded="false">
										Product Description
									</a>
									<div className="dropdown-menu" aria-labelledby="pdsDropdown">
										<a target="_blank" className="dropdown-item" href="../storage/pdf/PDS-Home-Protector-Enhanced.pdf">Home Protector Enhanced</a>
										<a target="_blank" className="dropdown-item" href="../storage/pdf/SmartHome Optimum (Enhanced) PDS.pdf">SmartHome Optimum (Enhanced)</a>
									</div>
								</li> */}
								<li className="nav-item">
									<a className="btn btn-outline-primary text-white fw-bold" href="/Faq">FAQs</a>
								</li>
								<li className="nav-item">
									<a className="btn btn-outline-primary text-white fw-bold" href="/claims">Contact Us & Claims</a>
								</li>
							</ul>
						</div>
					</div>
				</nav>
				<ScrollToTop />

				<Routes>
					<Route path="/success" element={<PaymentSuccess />} />
					<Route
						path="/LANDING"
						element={
						<LANDING
								basicName={basicName}
								setBasicName={setBasicName}
								basicEmailAdd={basicEmailAdd}
								setBasicEmailAdd={setBasicEmailAdd}
								basicContactNo={basicContactNo}
								setBasicContactNo={setBasicContactNo}
								setReferral={setReferral}
								referral={referral}
						/>
						}
					/>
					<Route
						path="/HHO"
						element={
							<HHO
								basicName={basicName}
								setReferral={setReferral}
								referral={referral}
								basicEmailAdd={basicEmailAdd}
								basicContactNo={basicContactNo}
							/>
						}
					/>
					<Route path="/Faq" element={<FAQ />} />
					<Route path="/claims" element={<CLAIM />} />
				</Routes>
			</div>
			<section id="footer" className="mt-4 me-3">
				<div className="row">
					<div className="col-12">
						<footer id="home-footer">
							<div className="container">
								<div className="row">
									<div className="col-12 col-sm-7 text-center text-sm-start">
										<a href={process.env.MIX_INSTAPOL_DOMAIN}>
											<img src="../images/new-logo-02.png" id="instapol-logo" alt="Instapol" width={150} loading="lazy" />
										</a>
										<div className="d-flex row mt-3">
											<div className="col-4 col-sm-3 border-end">
												<a className="btn btn-link" href={process.env.MIX_INSTAPOL_DOMAIN + "/privacy-policy"}>
													Privacy Notice
												</a>
											</div>
											<div className="col-4 col-sm-3 border-end">
												<a className="btn btn-link" href={process.env.MIX_INSTAPOL_DOMAIN + "/refund-policy"}>
													Refund Policy
												</a>
											</div>
											<div className="col-4 col-sm-3 border-end">
												<a className="btn btn-link" href={process.env.MIX_INSTAPOL_DOMAIN + "/term-of-use"}>
													Terms &amp; Conditions
												</a>
											</div>
											<div className="col-4 col-sm-3">
												<a className="btn btn-link" href="https://www.howdengroup.com/my-en/complaints_handling">
													Complaints Handling and Resolution Guide
												</a>
											</div>

										</div>
										<p>Copyright &copy; 2021 Instapol. All rights reserved.</p>
									</div>
									<div className="col-12 col-sm-5 text-center text-sm-end mt-4 mt-sm-0">
										<p>Developed and owned by</p>
										<a href="https://www.howdengroup.com/my-en">
											<img src="../images/new-howden-logo-navy.png" id="howden-logo" alt="Howden Insurance Brokers Sdn Bhd" width={200} loading="lazy" />
										</a>
										<p className="mt-3 mb-0">Howden Insurance Brokers Sdn. Bhd. (197801001023)</p>
										<p>Howden Takaful Brokers Sdn. Bhd. (198001010734)</p>
									</div>
								</div>
							</div>
						</footer>
					</div>
				</div>
			</section>
		</Router>
	);
}